// INTERCEPTAR FORMULÁRIOS DE PRODUTO IMEDIATAMENTE
(function() {  
  const interceptProductForms = () => {
    const productForms = document.querySelectorAll('form[action*="cart/add"]');
    
    productForms.forEach((form, index) => {
      
      // Remover event listeners existentes
      const newForm = form.cloneNode(true);
      form.parentNode.replaceChild(newForm, form);
      
      // Adicionar nosso listener
      newForm.addEventListener('submit', function(e) {
        newForm.querySelector('#AddToCart').classList.add('loading');
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Validar formulário
        if (!this.reportValidity()) {
          return;
        }
        
        // Preparar dados
        const formData = new FormData(this);
        
        // Adicionar seções necessárias
        const sectionsToRender = [
          { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
          { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
          { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
        ];
        
        formData.append('sections', sectionsToRender.map(section => section.section));
        formData.append('sections_url', window.location.pathname);
                
        // Fazer requisição AJAX
        fetch('/cart/add', {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript'
          },
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          if (data.status) {
            console.log('Cart add error:', data.description);
            return;
          }
          
          // Atualizar seções do carrinho
          sectionsToRender.forEach(section => {
            const element = document.getElementById(section.id);
            if (!element) return;
            
            // Para o Cart-Drawer, atualizar apenas o conteúdo interno
            if (section.id === 'Cart-Drawer') {
              const innerContent = element.querySelector('.side-panel-inner');
              if (innerContent && data.sections && data.sections[section.section]) {
                // Extrair apenas o conteúdo interno da resposta
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = data.sections[section.section];
                const newInnerContent = tempDiv.querySelector('.side-panel-inner');
                if (newInnerContent) {
                  innerContent.innerHTML = newInnerContent.innerHTML;
                }
              }
            } else {
              // Para outras seções, usar o método original
              const elementToReplace = element.querySelector(section.selector) || element;
              if (data.sections && data.sections[section.section]) {
                elementToReplace.innerHTML = data.sections[section.section];
              }
            }
          });
          
          // Abrir mini-cart
          // const cartDrawer = document.getElementById('Cart-Drawer');
          // if (cartDrawer) {
          //   cartDrawer.classList.add('active');
          //   document.body.classList.add('open-cart');
          //   document.body.classList.add('open-cc');
          // }
          newForm.querySelector('#AddToCart').classList.remove('loading');
        })
        .catch(error => {
          console.error('Cart add error:', error);
        });
      }, true);
    });
  };
  
  // Executar imediatamente e após delays
  interceptProductForms();
  setTimeout(interceptProductForms, 1000);
})();

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.addEventListener('change', (event)=> {this.updateLabelCor(event)})
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        if (!this.productSlider) {
          this.productSlider = this.productWrapper.querySelector('.product-carousel-with-thumbnails, .product-gallery-swiper-wrapper');
        }
        this.hideVariants = this.productSlider ? this.productSlider.dataset.hideVariants === 'true' : false;
      }
    }

    connectedCallback() {
      if (this.updateUrl) {
        this.updateOptions();
        this.updateMasterId();
        this.setDisabled();
        this.setImageSet();
        this.updateThumbnailsForVariant();
      }
      
      document.addEventListener('swiper:cache-ready', () => {
        this.updateThumbnailsForVariant();
      }, { once: true });

    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();
      //this.updateLabelCor();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateThumbnailsForVariant();
        this.updateURL();
        this.updateVariantInput();
        if (!window.location.pathname.startsWith("/pages/") || window.location.pathname.includes("lp-pet-bed")) {
          this.renderProductInfo();
        } else {
          this.renderProductInfoPages();
        }
        //this.updateShareUrl();
      }
      this.updateOther();
      this.updateScarcityWarning();
      this.updateRarelyAvailableBadge();
      this.updateVariantCustomBadges();
      
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });

    }

    updateLabelCor(event) {
      if(!window.variantsColors) return;
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));

      fieldsets.forEach((item, i) => {
        const label = item.querySelector('.form__label__text');
        const selectedValue = this.options[i];

        const variantColor = window.variantsColors.find(variant => {
          return Array.isArray(variant.metaobject_colors?.values) &&
            variant.metaobject_colors.values.some(color => color.label === selectedValue);
        });
        
        const hasGroupColors = item.dataset.isGrouped === 'true';

        if (!selectedValue) {
          if (hasGroupColors) {
            const groupTexts = item.querySelectorAll('.form__label__text');
            groupTexts.forEach(el => { el.innerHTML = ''; });
            const selectedTexts = item.querySelectorAll('.form__label__text__selected');
            selectedTexts.forEach(el => { el.innerHTML = ''; });
          } else if (label) {
            label.innerHTML = '';
          }
          const valueSpan = item.querySelector('.form__label__value');
          if (valueSpan) { valueSpan.innerHTML = ''; }
          return;
        }

        if(hasGroupColors){
          const labels = item.querySelectorAll('.form__label__text');
          const groupId = event.target.getAttribute('data-group-id');
          const selectedContainer = event.target.parentElement.parentElement.querySelector(`[data-color-group="${groupId}"]`).parentElement.querySelector('.form__label__text');
          const otherLabels = Array.from(item.querySelectorAll('.form__label__text')).filter(el => el !== selectedContainer);
          
          const html = `<strong>${variantColor.title_material}</strong> ${variantColor.content_material} ${variantColor.separator}`;
          selectedContainer.innerHTML = html;

          otherLabels.forEach(otherLabel => {
            otherLabel.innerHTML = '';
          });
          return;
        }

        if (!label) {
          return;
        }

        if (variantColor && !hasGroupColors) {
          const html = `<strong>${variantColor.title_material}</strong> ${variantColor.content_material} ${variantColor.separator} <strong>${variantColor.title_color}</strong>`;
          label.innerHTML = html;
        } else {
          label.innerHTML = `<strong>Color:</strong>`;
        }
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked')?.value);
          this.option_keys.push(fieldset.querySelector('input').name);
        }
      });
      this.dataset.options = this.options;
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');

        let labelDimension = item.querySelector('.form__label__value-dimension');
        const size_dimension = item.dataset.sizeDimension ? JSON.parse(item.dataset.sizeDimension) : null;

        if (label) {
          label.innerHTML = this.options[i] || '';
        }

        if (size_dimension && this.options[i]) {
          const selected_option = String(this.options[i]).toLowerCase();
          
          const dimension_info = size_dimension.find(dimension => {
            return String(dimension.size).toLowerCase() === selected_option;
          })
          if (dimension_info && labelDimension) {
            labelDimension.innerHTML = dimension_info.dimension;
          }
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    //here 2
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);


      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      if (!activeMedia) return;

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      if (!this.sticky) {
        window.setTimeout(() => {
          if (window.innerWidth > 1068) {
            let header_h = activeMedia.parentElement.offsetTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')),
              scroll_obj = {
                left: 0,
                behavior: 'instant'
              };

            if (header_h > 0) {
              scroll_obj.top = header_h;
            }
            window.scrollTo(scroll_obj);
          }
          activeMedia.parentElement.scrollTo({
            left: 0,
            behavior: 'instant'
          });
        });
      }

    }

    updateURL() {
      if (!this.currentVariant) return;
      const url = new URL(window.location);
      url.searchParams.set('variant', this.currentVariant.id);
      history.replaceState({}, '', url);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    // Update Scarcity Warning Variant
    updateScarcityWarning() {
        // Check if a variant is selected
        if (!this.currentVariant) {
            return;
        }

        // Find the <span> element with the data-variant-id attribute equal to the selected variant's ID
        const variantMetafieldElement = document.querySelector(
            `span[data-variant-id="${this.currentVariant.id}"]`
        );

        // Check if the element is found and extract the metafield value
        const scarcityMetafield = variantMetafieldElement
            ? variantMetafieldElement.getAttribute('data-scarcity-metafield')
            : null;

        // Find the container and the scarcity warning text
        const scarcityWarningContainer = document.getElementById('scarcity-warning-container');
        const scarcityWarningText = document.getElementById('scarcity-warning-text');

        // If the metafield has a value and is not empty
        if (scarcityWarningContainer && scarcityMetafield && scarcityMetafield !== "") {
            // Make the scarcity warning container visible
            scarcityWarningContainer.style.display = 'inline-block';

            // Update the scarcity warning text with the metafield value
            scarcityWarningText.innerHTML = scarcityMetafield;
        } else if (scarcityWarningContainer) {
            // Hide the container if there is no value to display
            scarcityWarningContainer.style.display = 'none';
        }
    }

    // Update Rarely Badge
    updateRarelyAvailableBadge() {
        // Check if a variant has been selected
        if (!this.currentVariant) {
            return;
        }

        // Find the <span> element corresponding to the selected variant using the data-variant-id attribute
        const variantMetafieldElement = document.querySelector(
            `span[data-variant-id="${this.currentVariant.id}"][data-rarely-available-metafield]`
        );

        // Check if the element was found and extract the metafield value
        const rarelyAvailableMetafield = variantMetafieldElement
            ? variantMetafieldElement.getAttribute('data-rarely-available-metafield')
            : null;

        // References to the container and the badge text
        const rarelyAvailableContainer = document.getElementById('rarely-available-container');
        const rarelyAvailableText = document.getElementById('rarely-available-text');

        // If the metafield has a value, show the badge
        if (rarelyAvailableMetafield && rarelyAvailableMetafield.trim() !== "") {

            // Update the text in the container
            rarelyAvailableText.textContent = rarelyAvailableMetafield;

            // Make the container visible
            rarelyAvailableContainer.style.display = 'inline-block';
        } else {
            // Hide the container if there is no value
            rarelyAvailableContainer.style.display = 'none';
        }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfoPages() {
      const productHandle = JSON.parse(localStorage.getItem('selectedProductHandle'));

      if (!productHandle || !this.currentVariant) {
        return;
      }
      const isMainProductNew = document.querySelector(".content-main-product");
      if (isMainProductNew) {
        return;
      }

      fetch(`/products/${productHandle}?variant=${this.currentVariant.id}`)
        .then(response => response.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          const dataPreorder = tempDiv.querySelector('#variants-information-preorder');
          const jsonPreorder = dataPreorder ? JSON.parse(dataPreorder.textContent) : null;
          if (jsonPreorder) this.verifyPreorder(jsonPreorder);

          const newPriceOf = tempDiv.querySelector('.price_of');
          const newPriceFor = tempDiv.querySelector('.price_for');

          if (newPriceOf && newPriceFor) {
            document.querySelector('.price_of').innerHTML = newPriceOf.innerHTML;
            document.querySelector('.price_for').innerHTML = newPriceFor.innerHTML;
          }
        })
        .catch(error => {
          console.error('Erro ao buscar informações do produto:', error);
        });
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          const dataPreorder = html.querySelector('#variants-information-preorder');
          const jsonPreorder = dataPreorder ? JSON.parse(dataPreorder.textContent) : null;
          if (jsonPreorder) this.verifyPreorder(jsonPreorder);

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant?.available, window.theme.variantStrings.soldOut);

        });
    }

    verifyPreorder(jsonPreorder) {
      if (!this.currentVariant) return;

      const variant = jsonPreorder[this.currentVariant.id];

      this.forcePreorderBehavior = variant.force_pre_order_behavior;
      this.preorder = variant.preorder;
      this.inventoryQuantity = variant.inventory_quantity;

      this.showReadyToShipBadge();
    }

    showReadyToShipBadge() {
      const readyToShipBadge = document.querySelector('.vg-badge-right .vg-img-right-first-image');
      if (!readyToShipBadge) return;

      if (this.preorder === 'continue' && (this.inventoryQuantity <= 0 || this.forcePreorderBehavior === 'true')) {
        readyToShipBadge.style.display = 'none';
      } else {
        readyToShipBadge.style.display = 'inline-block';
      }
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      let label = null;
      if (this.currentVariant) {
        label = document.querySelector(`label[data-variant-id="${this.currentVariant.id}"]`);
      }
      let isClassDisable = false;
      let input = null;
      if (label) {
        const parent = label.parentElement;
        input = parent.querySelector('input[type="radio"]');
      }
      if (input && input.classList.contains('is-disabled')) {
          isClassDisable = true;
      }

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          if (submitButton.classList.contains('not-klaviyo')) {
            if (document.querySelector('.rebuy-cart__flyout-item-property-value')) {
              text = window.theme.variantStrings.addToCart;
            }
            if (isClassDisable) {
              submitButton.setAttribute('disabled', 'disabled');
              text = 'SOLD OUT';
            }
          } else {
            // submitButton.classList.add('klaviyo-bis-trigger');
            submitButton.classList.add('sold-out');
          }
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('klaviyo-bis-trigger');
          submitButton.classList.remove('sold-out');
          submitButton.classList.remove('loading');

          // if (productTemplate?.includes('pre-order')) {
          //   submitButtonText.textContent = window.theme.variantStrings.preOrder;
          // } else {
            submitButtonText.textContent = window.theme.variantStrings.addToCart;
          // }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      // if (price) price.classList.add('visibility-hidden');
      // if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      this.showAllOptions();
      this.hideInvalidOptions();

      return true;
    }

    showAllOptions() {
      this.fieldsets.forEach((fieldset) => {
        fieldset.style.display = 'flex';

        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach(option => {
            option.disabled = false;
            option.style.display = 'block';
            option.style.pointerEvents = 'auto';
          });
        } else if (fieldset.querySelectorAll('input').length) {
          fieldset.querySelectorAll('input').forEach((input) => {
            input.classList.remove('is-disabled');
            input.style.display = 'block';
            input.style.pointerEvents = 'auto';

            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.style.display = 'inline-flex';
              label.style.pointerEvents = 'auto';
            }
          });
        }
      });
    }

    hideInvalidOptions() {
      const variant_data = this.getVariantData();
      if (!variant_data) return;

      const validCombinations = variant_data.map(variant => ({
        option1: variant.option1,
        option2: variant.option2,
        option3: variant.option3
      }));

      this.fieldsets.forEach((fieldset, fieldsetIndex) => {
        const currentOptions = [...this.options];

        if (fieldset.querySelector('select')) {
          fieldset.querySelectorAll('option').forEach(option => {
            if (!option.value) return;

            const testOptions = [...currentOptions];
            testOptions[fieldsetIndex] = option.value;

            const isValid = validCombinations.some(combination => {
              return testOptions.every((optionValue, index) => {
                const optionKey = `option${index + 1}`;
                return !optionValue || combination[optionKey] === optionValue;
              });
            });
            
            if (!isValid) {
              option.disabled = true;
              option.style.display = 'none';
            }
          });
        } else if (fieldset.querySelectorAll('input').length) {
          fieldset.querySelectorAll('input').forEach((input) => {
            if (!input.value) return;

            const testOptions = [...currentOptions];
            testOptions[fieldsetIndex] = input.value;

            const isValid = validCombinations.some(combination => {
              return testOptions.every((optionValue, index) => {
                const optionKey = `option${index + 1}`;
                return !optionValue || combination[optionKey] === optionValue;
              });
            });
            
            if (!isValid) {
              input.classList.add('is-disabled');

              const label = fieldset.querySelector(`label[for="${input.id}"]`);
              if (label) {
                label.style.pointerEvents = 'none';
              }
            }
          });
        }
      });
    }

    normalizeString(str) {
      if (!str) return '';
      
      return str
        .toLowerCase()
        .trim()
        .replace(/[àáâãäå]/g, 'a')
        .replace(/[èéêë]/g, 'e')
        .replace(/[ìíîï]/g, 'i')
        .replace(/[òóôõö]/g, 'o')
        .replace(/[ùúûü]/g, 'u')
        .replace(/[ñ]/g, 'n')
        .replace(/[ç]/g, 'c')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    }

    getImageSetName(variant_name) {
      return this.normalizeString(variant_name);
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]')?.dataset.index || 'option2';
        this.setImageSetMedia();
      }
    }

    // Função para comparar arrays
    arraysEqual(arr1, arr2) {
      if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
      return arr1.every(val => arr2.includes(val)) && arr2.every(val => arr1.includes(val));
    }

    arraysMatch(variantGroup, imageGroup) {
      if (!variantGroup || !imageGroup || imageGroup.length === 0) return false;
      
      // Filtrar "dimension" de ambos os arrays antes de comparar
      const filteredVariantGroup = variantGroup.filter(val => val !== 'dimension');
      const filteredImageGroup = imageGroup.filter(val => val !== 'dimension');
      
      if (filteredImageGroup.length === 0) return false;
      
      return filteredImageGroup.every(val => filteredVariantGroup.includes(val));
    }

    // Função para extrair grupo de dados
    extractGroupFromDataset(datasetGroup, imageSetName) {
      if (!datasetGroup || !imageSetName) return [];
      
      const groupPart = datasetGroup.split(`${imageSetName}_`);
      if (groupPart.length < 2) return [];
      
      return groupPart[1].split('_').filter(Boolean);
    }

    setImageSetMedia() {
      if (!this.imageSetIndex || !this.currentVariant?.options) {
        return;
      }

      const normalizedGroup = this.currentVariant.options.map(option => 
        this.normalizeString(option)
      );
      
      // Procurar tanto no productSlider quanto no document (para o caso do Swiper)
      let selectedSetImages = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);
      
      if (!selectedSetImages.length) {
        // Tentar buscar no document inteiro (para Swiper que pode estar em outro contexto)
        selectedSetImages = document.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);
      }
      
      if (!selectedSetImages.length) return;

      if (this.hideVariants) {
        selectedSetImages.forEach(thumb => {
          if (!thumb.dataset.group) return;
          
          const elementGroup = this.extractGroupFromDataset(thumb.dataset.group, this.imageSetName);
          const isActive = this.arraysMatch(normalizedGroup, elementGroup);
          
          thumb.classList.toggle('is-active', isActive);
        });
      } else {
        const activeImages = Array.from(selectedSetImages).filter(element => {
          if (!element.dataset.group) return false;
          
          const elementGroup = this.extractGroupFromDataset(element.dataset.group, this.imageSetName);
          return this.arraysMatch(normalizedGroup, elementGroup);
        });

        activeImages.forEach(thumb => {
          if (thumb.parentElement) thumb.parentElement.prepend(thumb);
        });
      }

      setTimeout(() => {
        this.productSlider.querySelector('product-slider')?.onPaginationResize();
      }, 100);
    }

    updateThumbnailsForVariant() {
      if (!window.swiperSlidesCache || !window.swiperSlidesCache.mainHTML.length) {
        return;
      }
      
      if (!this.imageSetName || !this.currentVariant) {
        return;
      }
      
      const mainSwiper = document.querySelector('.product-main-swiper');
      const thumbsSwiper = document.querySelector('.product-thumbnails-swiper');
      
      if (mainSwiper && mainSwiper.swiper) {
        this.reinitializeSwipers(mainSwiper, thumbsSwiper);
      } else {
        console.warn('⚠️ Swiper ainda não inicializado');
      }
    }
    
    reinitializeSwipers(mainSwiper, thumbsSwiper) {      
      if (!mainSwiper || !mainSwiper.swiper) {
        console.warn('❌ mainSwiper ou mainSwiper.swiper não encontrado');
        return;
      }
      
      const main = mainSwiper.swiper;
      const thumbs = thumbsSwiper?.swiper;
      
      if (!window.swiperSlidesCache) {
        window.swiperSlidesCache = {
          mainHTML: [],
          thumbsHTML: []
        };
        return;
      }
      
      const imageSetName = this.imageSetName;
      const normalizedGroup = this.currentVariant.options.map(option =>
        this.normalizeString(option)
      );
      
      const mainFiltered = window.swiperSlidesCache.mainHTML.filter(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const datasetGroup = slide?.getAttribute('data-group');
        
        if (!datasetGroup) return true;
        
        const elementGroup = this.extractGroupFromDataset(datasetGroup, imageSetName);
        return this.arraysMatch(normalizedGroup, elementGroup);
      });
      
      // Ordenar slides do main carousel filtrados pelo índice original para manter ordem correta
      const mainFilteredSorted = mainFiltered.map(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const slideIndex = parseInt(slide?.getAttribute('data-slide-index') || '0', 10);
        return { html, index: slideIndex };
      }).sort((a, b) => a.index - b.index).map(item => item.html);
      
      const thumbsFiltered = window.swiperSlidesCache.thumbsHTML.filter(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const datasetGroup = slide?.getAttribute('data-group');
        
        // Imagens compartilhadas (sem grupo) sempre visíveis
        if (!datasetGroup) return true;
        
        const elementGroup = this.extractGroupFromDataset(datasetGroup, imageSetName);
        return this.arraysMatch(normalizedGroup, elementGroup);
      });
      
      // Ordenar thumbnails filtradas pelo índice original para manter ordem correta
      const thumbsFilteredSorted = thumbsFiltered.map(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const slide = tempDiv.firstElementChild;
        const slideIndex = parseInt(slide?.getAttribute('data-slide-index') || '0', 10);
        return { html, index: slideIndex };
      }).sort((a, b) => a.index - b.index).map(item => item.html);
      
      const mainHTML = mainFilteredSorted.length ? mainFilteredSorted : window.swiperSlidesCache.mainHTML;
      const thumbsHTML = thumbsFilteredSorted.length ? thumbsFilteredSorted : window.swiperSlidesCache.thumbsHTML;
      
      // console.log(`📦 Cache total: ${window.swiperSlidesCache.mainHTML.length} slides`);
      // console.log(`✅ Filtrados: ${mainHTML.length} slides`);
      
      main.removeAllSlides();
      if (thumbs) {
        thumbs.removeAllSlides();
      }
      
      main.appendSlide(mainHTML);
      if (thumbs) {
        thumbs.appendSlide(thumbsHTML);
      }
      
      requestAnimationFrame(() => {
        main.update();
        if (thumbs) {
          thumbs.update();
        }
        
        main.slideTo(0, 0, false);
        if (thumbs) {
          thumbs.slideTo(0, 0, false);
        }
        
        if (main.params && main.params.on && main.params.on.slideChange) {
          main.off('slideChange');
        }
        
        // Adiciona novo listener de sincronização
        main.on('slideChange', () => {
          if (thumbs) {
            thumbs.slideTo(main.realIndex, 0, false);
          }
        });
      });
    }
    
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateVariantCustomBadges() {
      if (!this.currentVariant) return;

      const badgeDataElement = document.getElementById('variant-badges-data');
      if (!badgeDataElement) return;
      
      let allVariantBadges = {};
      try {
        allVariantBadges = JSON.parse(badgeDataElement.textContent);
      } catch (e) {
        console.log('Error parsing variant badges data:', e);
        return;
      }
      
      const badgeContainers = document.querySelectorAll('.vg-badge-left');
      const variantId = this.currentVariant.id;
      const variantBadges = allVariantBadges[variantId];

      if (variantBadges && variantBadges.badges && Array.isArray(variantBadges.badges)) {
        badgeContainers.forEach(container => {
          container.innerHTML = '';
          this.renderBadges(container, variantBadges.badges);
        });
      }
    }

    renderBadges(container, badges) {
      if (!badges || !Array.isArray(badges)) return;
      
      badges.forEach(badge => {
        const badgeElement = this.createBadgeElement(badge);
        container.appendChild(badgeElement);
      });
    }

    createBadgeElement(badge) {
      const badgeElement = document.createElement('span');
      badgeElement.className = 'badge badge-custom-icon';
      
      if (badge.image) {
        const img = document.createElement('img');
        img.src = badge.image;
        img.className = 'badge badge-custom badge-custom-image';
        img.style.width = `${badge.image_width || 100}px`;
        img.loading = 'lazy';

        return img;
      } else {
        badgeElement.style.backgroundColor = badge.background_color || '#000000';
        badgeElement.style.borderColor = badge.background_color || '#000000';
        badgeElement.style.color = badge.text_color || '#ffffff';
        
        if (badge.icon) {
          const icon = document.createElement('img');
          icon.src = badge.icon;
          icon.className = 'badge-custom';
          icon.style.width = `${badge.icon_width || 16}px`;
          icon.loading = 'lazy';
          badgeElement.appendChild(icon);
        }
        
        const text = document.createElement('span');
        text.textContent = badge.text;
        badgeElement.appendChild(text);
        
        return badgeElement;
      }
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}
//HERE
if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

      // Start Gallery
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });

      this.setupProductGallery();

      // Start Pagination
      if (this.pagination) {
        this.setupPagination();
        this.resizeObserver = new ResizeObserver(entries => {
          this.onPaginationResize();
        });
        this.resizeObserver.observe(this);
        this.addEventListener('scroll', this.updatePagination.bind(this));
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }

      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        if (!item.querySelector('.product-single__media-zoom')) return;
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };

      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);

          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });

    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;

      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');

      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');


      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));

      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);

      if (this.sliderItemsToShow.length < 2) return;

      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.updatePagination();
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({
        left: this.slideScrollPosition
      });
    }
    updatePagination() {
      if (!this.nextButton) return;

      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.pageTotalElement) {
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }

      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }

  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }
    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');

        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');

            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }

        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}



if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

document.addEventListener("mouseenter", function (event) {
    if (event.target instanceof HTMLElement && event.target.closest(".badge_popup")) {
        const popup = document.querySelector(".black_friday_popup");
        if (popup) popup.style.display = "block";
    }
}, true);

document.addEventListener("mouseleave", function (event) {
    if (event.target instanceof HTMLElement && event.target.closest(".badge_popup")) {
        const popup = document.querySelector(".black_friday_popup");
        if (popup) popup.style.display = "none";
    }
}, true);

/**
 * Rove Sticky Add to Cart Component
 */
if (!customElements.get('rove-sticky-add-to-cart')) {
  class RoveStickyAddToCart extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.section;
      this.originalAddToCartButton = null;
      this.intersectionObserver = null;
      this.isVisible = false;
    }

    connectedCallback() {
      console.log('RoveStickyAddToCart connected');
      
      // Ensure component starts hidden
      this.style.display = 'none';
      this.classList.remove('rove-sticky--visible');
      this.isVisible = false;
      
      // Wait for page to be fully loaded before setting up
      if (document.readyState === 'complete') {
        this.initializeComponent();
      } else {
        window.addEventListener('load', () => {
          this.initializeComponent();
        });
      }
      
      this.setupVariantChangeListener();
    }

    initializeComponent() {
      console.log('Initializing sticky component after page load');
      // Try multiple approaches to find the button
      this.findAddToCartButton();
      
      // Set up Rebuy cart integration
      this.setupRebuyCart();
      
      // Set up initial color swatch
      this.setupInitialColorSwatch();
      
      // Listen for window resize to recalculate chat button position
      window.addEventListener('resize', () => {
        if (this.isVisible) {
          this.adjustChatButton();
        }
      });
    }

    setupInitialColorSwatch() {
      // Wait a bit for the swatches to be fully rendered
      setTimeout(() => {
        this.attemptInitialColorSwatchSetup();
      }, 100);

      // Also try again after a longer delay to ensure everything is loaded
      setTimeout(() => {
        this.attemptInitialColorSwatchSetup();
      }, 500);
    }

    attemptInitialColorSwatchSetup() {
      // Get the current variant from the main product
      const mainProductForm = document.querySelector(`#product-form-${this.sectionId}`);
      if (mainProductForm) {
        const variantId = mainProductForm.querySelector('input[name="id"]').value;
        const currentVariant = window.productData?.variants?.find(v => v.id == variantId);
        
        if (currentVariant) {
          console.log('Setting up initial color swatch for variant:', currentVariant);
          this.updateColorSwatch(currentVariant);
        } else {
          // Fallback: try to get variant from the active swatch
          const activeSwatch = this.findActiveSwatch();
          if (activeSwatch) {
            console.log('Setting up initial color swatch from active swatch:', activeSwatch);
            this.updateColorSwatchFromActiveSwatch(activeSwatch);
          } else {
            console.log('No active swatch found for initial setup');
          }
        }
      } else {
        console.log('No product form found for initial setup');
      }

      // Update badges positioning on initial setup
      this.updateBadgesPosition();
    }

    updateColorSwatchFromActiveSwatch(activeSwatch) {
      const colorSwatch = this.querySelector('.color-swatch');
      if (!colorSwatch || !activeSwatch) return;

      console.log('Updating from active swatch:', activeSwatch);
      
      // Get the background image from the active swatch
      const computedStyle = window.getComputedStyle(activeSwatch);
      const backgroundImage = computedStyle.getPropertyValue('background-image');
      const backgroundColor = computedStyle.getPropertyValue('background-color');
      
      console.log('Active swatch background image:', backgroundImage);
      console.log('Active swatch background color:', backgroundColor);
      
      if (backgroundImage && backgroundImage !== 'none' && backgroundImage !== 'url()') {
        // Extract the image URL from the background-image CSS
        const imageUrl = backgroundImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
        console.log('Extracted image URL:', imageUrl);
        
        // Use the image from the active swatch
        colorSwatch.innerHTML = `<img src="${imageUrl}" alt="Color swatch" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
        console.log('Updated sticky swatch with active swatch image:', imageUrl);
      } else if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
        // Use the background color from the active swatch
        colorSwatch.style.backgroundColor = backgroundColor;
        colorSwatch.innerHTML = '';
        console.log('Updated sticky swatch with active swatch color:', backgroundColor);
      } else {
        // Try to get the CSS custom properties from the active swatch
        const colorImage = computedStyle.getPropertyValue('--option-color-image');
        const colorValue = computedStyle.getPropertyValue('--option-color');
        
        if (colorImage && colorImage !== 'none') {
          const cleanImageUrl = colorImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
          colorSwatch.innerHTML = `<img src="${cleanImageUrl}" alt="Color swatch" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
          console.log('Updated sticky swatch with CSS custom property image:', cleanImageUrl);
        } else if (colorValue && colorValue !== 'none') {
          colorSwatch.style.backgroundColor = colorValue;
          colorSwatch.innerHTML = '';
          console.log('Updated sticky swatch with CSS custom property color:', colorValue);
        } else {
          // Final fallback
          const fallbackColor = 'espresso'; // Default fallback
          colorSwatch.style.backgroundColor = fallbackColor;
          colorSwatch.innerHTML = '';
          console.log('Updated sticky swatch with fallback color:', fallbackColor);
        }
      }
    }

    setupRebuyCart() {
      // Wait for Rebuy to be available
      const checkRebuy = () => {
        if (window.Rebuy && window.Rebuy.Cart) {
          console.log('Rebuy Cart available, setting up integration');
          this.setupRebuyFormHandler();
        } else {
          console.log('Rebuy Cart not available yet, retrying...');
          setTimeout(checkRebuy, 100);
        }
      };
      checkRebuy();
    }

    setupRebuyFormHandler() {
      const form = this.querySelector('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.handleRebuyAddToCart();
        });
      }
    }

    handleRebuyAddToCart() {
      const form = this.querySelector('form');
      if (!form || !window.Rebuy || !window.Rebuy.Cart) {
        console.log('Rebuy Cart not available, falling back to standard form submission');
        form.submit();
        return;
      }

      const formData = new FormData(form);
      const variantId = formData.get('id');
      
      if (!variantId) {
        console.log('No variant ID found');
        return;
      }

      const data = {
        id: parseInt(variantId),
        quantity: 1
      };

      const options = {
        onSuccess: (response) => {
          console.log('Rebuy add to cart success:', response);
          // Trigger cart update events
          document.dispatchEvent(new CustomEvent('cart:updated'));
        },
        onError: (error) => {
          console.error('Rebuy add to cart error:', error);
          // Fallback to standard form submission
          form.submit();
        }
      };

      console.log('Adding item to cart via Rebuy:', data);
      window.Rebuy.Cart.addItem(data, options);
    }

    disconnectedCallback() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
      }
      if (this.mutationObserver) {
        this.mutationObserver.disconnect();
      }
    }

    findAddToCartButton() {
      console.log('Looking for AddToCart button...');
      
      // Try immediate search
      this.originalAddToCartButton = document.querySelector(`#AddToCart`);
      console.log('Immediate search result:', this.originalAddToCartButton);
      
      if (this.originalAddToCartButton) {
        console.log('Found AddToCart button immediately');
        this.setupIntersectionObserver();
        return;
      }

      // Try multiple selectors
      const selectors = [
        '#AddToCart',
        'button[id*="AddToCart"]',
        'button[class*="add-to-cart"]',
        '.single-add-to-cart-button',
        'button[name="add"]'
      ];

      for (const selector of selectors) {
        this.originalAddToCartButton = document.querySelector(selector);
        if (this.originalAddToCartButton) {
          console.log('Found AddToCart button with selector:', selector);
          this.setupIntersectionObserver();
          return;
        }
      }

      // If still not found, show sticky by default
      console.log('AddToCart button not found - showing sticky by default');
      this.showSticky();
    }

    setupIntersectionObserver() {
      if (!this.originalAddToCartButton) return;

      console.log('Setting up intersection observer for AddToCart button:', this.originalAddToCartButton);

      // Create intersection observer
      this.intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          console.log('Intersection observer triggered:', {
            target: entry.target,
            intersectionRatio: entry.intersectionRatio,
            isIntersecting: entry.isIntersecting,
            boundingClientRect: entry.boundingClientRect
          });
          
          if (entry.target === this.originalAddToCartButton) {
            // Only show sticky if the button is completely above the viewport (user scrolled past it)
            // Don't show if the button is below the viewport (user hasn't reached it yet)
            if (entry.intersectionRatio === 0 && entry.boundingClientRect.bottom < 0) {
              console.log('AddToCart button scrolled past (above viewport) - showing sticky');
              this.showSticky();
            } else {
              console.log('AddToCart button visible or below viewport - hiding sticky');
              this.hideSticky();
            }
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px'
      });

      // Start observing
      this.intersectionObserver.observe(this.originalAddToCartButton);
      console.log('Started observing AddToCart button');
      
      // Check initial visibility after a delay to allow page to fully render
      setTimeout(() => {
        console.log('Checking initial visibility after render delay...');
        this.checkInitialVisibility();
      }, 100);
    }

    checkInitialVisibility() {
      if (this.originalAddToCartButton) {
        const rect = this.originalAddToCartButton.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        
        const isVisible = rect.top >= 0 && rect.left >= 0 && 
                         rect.bottom <= windowHeight && 
                         rect.right <= windowWidth;
        
        console.log('AddToCart button initial visibility check:', {
          isVisible,
          buttonRect: {
            top: rect.top,
            left: rect.left,
            bottom: rect.bottom,
            right: rect.right,
            width: rect.width,
            height: rect.height
          },
          windowSize: {
            height: windowHeight,
            width: windowWidth
          },
          scrollPosition: {
            scrollY: window.scrollY,
            scrollX: window.scrollX
          }
        });
        
        if (!isVisible) {
          console.log('AddToCart button is NOT visible initially - showing sticky');
          this.showSticky();
        } else {
          console.log('AddToCart button IS visible initially - hiding sticky');
          this.hideSticky();
        }
      } else {
        console.log('AddToCart button not found for initial visibility check');
      }
    }

    setupVariantChangeListener() {
      // Listen for variant changes to update color and price
      document.addEventListener('product:variant-change', (event) => {
        if (event.detail.sectionId === this.sectionId) {
          this.updateVariantInfo(event.detail.variant);
        }
      });
    }

    updateVariantInfo(variant) {
      if (!variant) return;

      // Update color name
      const colorNameElement = this.querySelector('#sticky-selected-color');
      if (colorNameElement && variant.option1) {
        colorNameElement.textContent = variant.option1;
      }

      // Update color swatch with proper color/image
      this.updateColorSwatch(variant);

      // Update price - use the same price rendering as the main product
      const priceElement = this.querySelector(`#sticky-price-${this.sectionId}`);
      if (priceElement) {
        // Get the price from the main product price element to maintain consistency
        const mainPriceElement = document.querySelector(`#price-${this.sectionId}`);
        if (mainPriceElement) {
          priceElement.innerHTML = mainPriceElement.innerHTML;
        } else {
          // Fallback to manual price formatting
          const price = new Intl.NumberFormat('en-CA', {
            style: 'currency',
            currency: 'CAD'
          }).format(variant.price / 100);
          
          priceElement.innerHTML = `<span class="price">${price}</span>`;
        }
      }

      // Update button state
      const button = this.querySelector('#StickyAddToCart');
      if (button) {
        if (variant.available) {
          button.disabled = false;
          button.classList.remove('sold-out');
          button.querySelector('.single-add-to-cart-button--text').textContent = 'ADD TO CART';
        } else {
          button.disabled = true;
          button.classList.add('sold-out');
          button.querySelector('.single-add-to-cart-button--text').textContent = 'SOLD OUT';
        }
      }

      // Update hidden input with new variant ID
      const hiddenInput = this.querySelector('input[name="id"]');
      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      // Update badges positioning based on color text width
      this.updateBadgesPosition();
    }

    updateColorSwatch(variant) {
      const colorSwatch = this.querySelector('.color-swatch');
      if (!colorSwatch || !variant.option1) return;

      console.log('updateColorSwatch called with variant:', variant);
      console.log('Looking for color option:', variant.option1);

      // Find the currently active/selected swatch in the main product
      const activeSwatch = this.findActiveSwatch();
      
      if (activeSwatch) {
        console.log('Found active swatch:', activeSwatch);
        
        // Get the background image from the active swatch
        const computedStyle = window.getComputedStyle(activeSwatch);
        const backgroundImage = computedStyle.getPropertyValue('background-image');
        const backgroundColor = computedStyle.getPropertyValue('background-color');
        
        console.log('Active swatch background image:', backgroundImage);
        console.log('Active swatch background color:', backgroundColor);
        
        if (backgroundImage && backgroundImage !== 'none' && backgroundImage !== 'url()') {
          // Extract the image URL from the background-image CSS
          const imageUrl = backgroundImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
          console.log('Extracted image URL:', imageUrl);
          
          // Use the image from the active swatch
          colorSwatch.innerHTML = `<img src="${imageUrl}" alt="${variant.option1}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
          console.log('Updated sticky swatch with active swatch image:', imageUrl);
        } else if (backgroundColor && backgroundColor !== 'rgba(0, 0, 0, 0)' && backgroundColor !== 'transparent') {
          // Use the background color from the active swatch
          colorSwatch.style.backgroundColor = backgroundColor;
          colorSwatch.innerHTML = '';
          console.log('Updated sticky swatch with active swatch color:', backgroundColor);
        } else {
          // Try to get the CSS custom properties from the active swatch
          const colorImage = computedStyle.getPropertyValue('--option-color-image');
          const colorValue = computedStyle.getPropertyValue('--option-color');
          
          if (colorImage && colorImage !== 'none') {
            const cleanImageUrl = colorImage.replace(/url\(['"]?([^'"]*)['"]?\)/, '$1');
            colorSwatch.innerHTML = `<img src="${cleanImageUrl}" alt="${variant.option1}" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">`;
            console.log('Updated sticky swatch with CSS custom property image:', cleanImageUrl);
          } else if (colorValue && colorValue !== 'none') {
            colorSwatch.style.backgroundColor = colorValue;
            colorSwatch.innerHTML = '';
            console.log('Updated sticky swatch with CSS custom property color:', colorValue);
          } else {
            // Final fallback
            const fallbackColor = variant.option1.toLowerCase().replace(/\s+/g, '-');
            colorSwatch.style.backgroundColor = fallbackColor;
            colorSwatch.innerHTML = '';
            console.log('Updated sticky swatch with fallback color:', fallbackColor);
          }
        }
      } else {
        console.log('No active swatch found, using fallback');
        // Fallback to background color if no active swatch found
        const colorValue = variant.option1.toLowerCase().replace(/\s+/g, '-');
        colorSwatch.style.backgroundColor = colorValue;
        colorSwatch.innerHTML = '';
        console.log('Updated sticky swatch with fallback color:', colorValue);
      }

      colorSwatch.setAttribute('data-color', variant.option1);
    }

    findActiveSwatch() {
      // Look for the currently selected/active swatch in the main product
      let activeSwatch = null;

      // Method 1: Look for checked radio button and find its corresponding label
      const checkedRadio = document.querySelector('input[type="radio"][name="Color"]:checked');
      if (checkedRadio) {
        console.log('Found checked radio:', checkedRadio);
        const label = document.querySelector(`label[for="${checkedRadio.id}"]`);
        if (label) {
          activeSwatch = label;
          console.log('Found active swatch by checked radio:', label);
        }
      }

      // Method 2: Look for elements with active/selected classes
      if (!activeSwatch) {
        const activeElements = document.querySelectorAll('.product-option label.active, .product-option label.selected, .product-option .active label, .product-option .selected label');
        if (activeElements.length > 0) {
          activeSwatch = activeElements[0];
          console.log('Found active swatch by class:', activeSwatch);
        }
      }

      // Method 3: Look for the swatch that matches the current variant
      if (!activeSwatch) {
        const currentVariantId = document.querySelector('input[name="id"]')?.value;
        if (currentVariantId) {
          const swatchLabels = document.querySelectorAll('.product-option label[data-variant-id]');
          swatchLabels.forEach(label => {
            const variantId = label.getAttribute('data-variant-id');
            if (variantId && parseInt(variantId) === parseInt(currentVariantId)) {
              activeSwatch = label;
              console.log('Found active swatch by variant ID:', label);
            }
          });
        }
      }

      // Method 4: Look for the first visible swatch (fallback)
      if (!activeSwatch) {
        const swatchLabels = document.querySelectorAll('.product-option label');
        if (swatchLabels.length > 0) {
          activeSwatch = swatchLabels[0];
          console.log('Using first swatch as fallback:', activeSwatch);
        }
      }

      return activeSwatch;
    }

    updateBadgesPosition() {
      // Use requestAnimationFrame to ensure the DOM is fully updated
      requestAnimationFrame(() => {
        // Add a small delay to ensure the element is fully rendered
        setTimeout(() => {
          this.attemptBadgesPositionUpdate();
        }, 10);
      });
    }

    attemptBadgesPositionUpdate() {
      const colorTextElement = this.querySelector('#sticky-selected-color');
      const badgesElement = this.querySelector('.rove-sticky-add-to-cart--price .badges');
      
      if (colorTextElement && badgesElement) {
        // Get the width of the color text
        const colorTextWidth = colorTextElement.getBoundingClientRect().width;
        const badgesWidth = badgesElement.getBoundingClientRect().width;
        const isMobile = window.innerWidth < 768;
        
        console.log('Color text element:', colorTextElement);
        console.log('Color text content:', colorTextElement.textContent);
        console.log('Color text width:', colorTextWidth);
        if (isMobile) {
          badgesElement.style.display = 'none !important';
        } else {
          badgesElement.style.display = 'block !important';
        }
        
        if (colorTextWidth > 0) {
          // Set the right property of the badges to match the color text width
          badgesElement.style.left = `${colorTextWidth + badgesWidth}px`;
          console.log('Updated badges position, color text width:', colorTextWidth);
        } else {
          // If width is still 0, try again after a longer delay
          console.log('Width is 0, retrying in 100ms...');
          setTimeout(() => {
            this.attemptBadgesPositionUpdate();
          }, 100);
        }
      } else {
        console.log('Could not find color text element or badges element for positioning');
        console.log('Color text element:', colorTextElement);
        console.log('Badges element:', badgesElement);
      }
    }

    showSticky() {
      console.log('showSticky called, isVisible:', this.isVisible);
      
      if (!this.isVisible) {
        console.log('Showing sticky component');
        this.style.display = 'block';
        // Force reflow
        this.offsetHeight;
        this.classList.add('rove-sticky--visible');
        this.isVisible = true;
        
        // Adjust chat button iframe position
        this.adjustChatButton();
        console.log('Sticky component should now be visible');
      }
    }

    hideSticky() {
      if (this.isVisible) {
        this.classList.remove('rove-sticky--visible');
        this.isVisible = false;
        
        // Reset chat button iframe position
        this.resetChatButton();
        
        // Hide after transition
        setTimeout(() => {
          if (!this.isVisible) {
            this.style.display = 'none';
          }
        }, 300);
      }
    }

    adjustChatButton() {
      const chatButton = document.querySelector('iframe#chat-button');
      if (chatButton) {
        // Calculate the height of the sticky component
        const stickyHeight = this.getBoundingClientRect().height;
        console.log('Sticky component height:', stickyHeight);
        
        // Apply the height as bottom distance to chat button with !important
        const bottomDistance = Math.max(stickyHeight + 24, 64); // Minimum 64px, or height + 16px padding
        chatButton.style.setProperty('bottom', `${bottomDistance}px`, 'important');
        
        console.log('Chat button bottom distance set to:', bottomDistance);
      }
    }

    resetChatButton() {
      const chatButton = document.querySelector('iframe#chat-button');
      if (chatButton) {
        // Reset to original position with !important to override CSS rules
        chatButton.style.setProperty('bottom', '', 'important');
        console.log('Chat button bottom distance reset');
      }
    }
  }

  customElements.define('rove-sticky-add-to-cart', RoveStickyAddToCart);
}